import { useEffect, useState } from 'react';
import { publicCatalogueRequest } from '../lib/public-catalogue-request';
import collectionPreview from '../data/discovery-preview.json';

const cache = new Map();
export const useDiscovery = section => {
  const [retry, setRetry] = useState(0);
  const initial = section === 'collection' ? collectionPreview.items : [];
  const [state, setState] = useState({ section, items: initial, loading: !initial.length, error: null });
  useEffect(() => {
    const controller = new AbortController();
    if (section === 'advanced') {
      setState({ section, items: [], loading: false, error: null });
      return () => controller.abort();
    }
    const saved = cache.get(section);
    if (saved && Date.now() - saved.at < 120000) {
      setState({ section, items: saved.items, loading: false, error: null });
      return () => controller.abort();
    }
    const preview = section === 'collection' ? collectionPreview.items : [];
    setState({ section, items: preview, loading: !preview.length, error: null });
    publicCatalogueRequest(`/search/discovery?section=${section}`, { signal: controller.signal })
      .then(data => {
        if (controller.signal.aborted) return;
        if (!Array.isArray(data.items)) throw new Error('Invalid catalogue response. Please try again.');
        cache.set(section, { at: Date.now(), items: data.items });
        setState({ section, items: data.items, loading: false, error: null });
      })
      .catch(error => { if (!controller.signal.aborted) setState({ section, items: [], loading: false, error: error.message }); });
    return () => controller.abort();
  }, [section, retry]);
  return { ...(state.section === section ? state : { items: [], loading: true, error: null }),
    retry: () => { cache.delete(section); setRetry(value => value + 1); } };
};